import { render, staticRenderFns } from "./eleConsReqDocPop.vue?vue&type=template&id=71dc4054&scoped=true"
import script from "./eleConsReqDocPop.vue?vue&type=script&lang=js"
export * from "./eleConsReqDocPop.vue?vue&type=script&lang=js"
import style0 from "./eleConsReqDocPop.vue?vue&type=style&index=0&id=71dc4054&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc4054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71dc4054')) {
      api.createRecord('71dc4054', component.options)
    } else {
      api.reload('71dc4054', component.options)
    }
    module.hot.accept("./eleConsReqDocPop.vue?vue&type=template&id=71dc4054&scoped=true", function () {
      api.rerender('71dc4054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/eleConsReqDocPop.vue"
export default component.exports